


































































import moment from 'moment'

import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { OrderPaymentFilters, OrderPaymentStatus } from '@/models'

import { isSetsEqual, normalizeDate } from '@/utils'

interface DateOptions {
  max?: string | null
  min?: string | null
}

@Component({
  components: {
    ListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class OrderPaymentFiltersForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: OrderPaymentFilters | null

  @Prop({ type: Object, required: true })
  readonly initialFilters!: OrderPaymentFilters

  isValid = false

  startDate = ''

  startDateOptions: DateOptions = {
    max: moment().format('YYYY-MM-DD')
  }

  endDate = ''

  endDateOptions: DateOptions = {
    min: null,
    max: moment().format('YYYY-MM-DD')
  }

  orderPaymentStatus: [OrderPaymentStatus, boolean][] = [
    [OrderPaymentStatus.WAITING, false],
    [OrderPaymentStatus.COMPLETED, false],
    [OrderPaymentStatus.CANCELED, false]
  ]

  OrderPaymentStatusTexts: Record<OrderPaymentStatus, string> = {
    [OrderPaymentStatus.WAITING]: 'Não Pago',
    [OrderPaymentStatus.COMPLETED]: 'Pago',
    [OrderPaymentStatus.CANCELED]: 'Cancelado'
  }

  get enabledOrderPaymentStatus () {
    return this.orderPaymentStatus
      .filter((entry) => entry[1])
      .map((entry) => entry[0])
  }

  get isFormValid () {
    return this.isValid
  }

  @Watch('data')
  onDataChange (filters: OrderPaymentFilters) {
    this.updateFields(filters)
  }

  @Watch('startDate')
  onStartDateChange (value: string) {
    const date = normalizeDate(value)

    this.endDateOptions.min = date

    this.updateModel()
  }

  @Watch('endDate')
  onEndDateChange (value: string) {
    const date = normalizeDate(value)

    this.startDateOptions.max = date ?? this.endDateOptions.max

    this.updateModel()
  }

  @Watch('orderPaymentStatus')
  onOrderPaymentStatusChange () {
    this.updateModel()
  }

  @Watch('isFormValid')
  onIsFormValidChange () {
    this.$emit('update:isValid', this.isFormValid)
  }

  created () {
    this.updateFields(this.initialFilters)
  }

  updateFields (filters: OrderPaymentFilters) {
    this.startDate = filters.startDate ?? ''
    this.endDate = filters.endDate ?? ''

    const statusFilter = filters.status ?? []

    if (!isSetsEqual(new Set(this.enabledOrderPaymentStatus), new Set(statusFilter))) {
      this.orderPaymentStatus = this.orderPaymentStatus
        .map((entry) => [entry[0], statusFilter.includes(entry[0])])
    }
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): OrderPaymentFilters {
    return {
      startDate: this.startDate || undefined,
      endDate: this.endDate || undefined,
      status: this.enabledOrderPaymentStatus
    }
  }

  submit () {
    if (this.isFormValid) {
      this.$emit('submit')
    }
  }
}
